// Mobile nav drawer — toggles aria-expanded + .is-open on the nav.

export function initMobileNav() {
	const toggle = document.querySelector('[data-cs-nav-toggle]');
	const nav = document.querySelector('[data-cs-nav]');
	if (!toggle || !nav) return;

	const setOpen = (isOpen) => {
		toggle.setAttribute('aria-expanded', String(isOpen));
		nav.classList.toggle('is-open', isOpen);
	};

	toggle.addEventListener('click', () => {
		setOpen(toggle.getAttribute('aria-expanded') !== 'true');
	});

	// Close after navigation click
	nav.addEventListener('click', (e) => {
		if (e.target.closest('a')) setOpen(false);
	});

	// Close on resize up to desktop
	let lastWide = window.innerWidth >= 1100;
	window.addEventListener('resize', () => {
		const wide = window.innerWidth >= 1100;
		if (wide && !lastWide) setOpen(false);
		lastWide = wide;
	});
}
